import { toLegacyDetail, toLegacyPaginated, v1Delete, v1Get, v1Post, v1Put } from '@/services/v1Api';

// Get all company transport types
export const getTransportTypes = async (filters = {}) => {
    try {
        console.log('[transportTypesService] Fetching company transport types with filters:', filters);

        const params = {};
        if (filters.search) params.search = filters.search;
        if (filters.sort_by) params.sort_by = filters.sort_by;
        if (filters.sort_order) params.sort_order = filters.sort_order;
        if (filters.per_page) params.per_page = filters.per_page;
        if (filters.page) params.page = filters.page;

        const { data, meta } = await v1Get('/api/v1/transport-types', params);
        const result = toLegacyPaginated(data, meta);
        console.log('[transportTypesService] Successfully fetched company transport types:', result);
        return result;
    } catch (error) {
        console.error('[transportTypesService] Error fetching company transport types:', {
            message: error.message,
            status: error.response?.status,
            statusText: error.response?.statusText,
            data: error.response?.data,
            filters: filters
        });
        throw error;
    }
};

// Get transport type by ID
export const getTransportTypeById = async (id) => {
    try {
        console.log(`[transportTypesService] Fetching transport type with ID: ${id}`);
        const { data } = await v1Get(`/api/v1/transport-types/${id}`);
        const result = toLegacyDetail(data);
        console.log(`[transportTypesService] Successfully fetched transport type ${id}:`, result);
        return result;
    } catch (error) {
        console.error(`[transportTypesService] Error fetching transport type ${id}:`, {
            message: error.message,
            status: error.response?.status,
            statusText: error.response?.statusText,
            data: error.response?.data
        });
        throw error;
    }
};

// Assign transport type to company
export const createTransportType = async (transportTypeData) => {
    try {
        console.log('[transportTypesService] Assigning transport type to company:', transportTypeData);
        const { data } = await v1Post('/api/v1/transport-types', transportTypeData);
        const result = toLegacyDetail(data);
        console.log('[transportTypesService] Successfully assigned transport type to company:', result);
        return result;
    } catch (error) {
        console.error('[transportTypesService] Error assigning transport type to company:', {
            message: error.message,
            status: error.response?.status,
            statusText: error.response?.statusText,
            data: error.response?.data,
            transportTypeData: transportTypeData
        });
        throw error;
    }
};

// Update company transport type
export const updateTransportType = async (id, transportTypeData) => {
    try {
        console.log(`[transportTypesService] Updating company transport type ${id}:`, transportTypeData);
        const { data } = await v1Put(`/api/v1/transport-types/${id}`, transportTypeData);
        const result = toLegacyDetail(data);
        console.log(`[transportTypesService] Successfully updated company transport type ${id}:`, result);
        return result;
    } catch (error) {
        console.error(`[transportTypesService] Error updating company transport type ${id}:`, {
            message: error.message,
            status: error.response?.status,
            statusText: error.response?.statusText,
            data: error.response?.data,
            transportTypeData: transportTypeData
        });
        throw error;
    }
};

// Remove transport type from company
export const deleteTransportType = async (id) => {
    try {
        console.log(`[transportTypesService] Removing transport type ${id} from company`);
        await v1Delete(`/api/v1/transport-types/${id}`);
        const result = { success: true };
        console.log(`[transportTypesService] Successfully removed transport type ${id} from company:`, result);
        return result;
    } catch (error) {
        console.error(`[transportTypesService] Error removing transport type ${id} from company:`, {
            message: error.message,
            status: error.response?.status,
            statusText: error.response?.statusText,
            data: error.response?.data
        });
        throw error;
    }
};
